import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import {
  deleteProduct,
  fetchProductsData,
  fetchSingleProduct,
  setProductsList,
  setViewedProduct,
} from './actions';
import {
  BASE_URL,
  PRODUCTS_URL,
} from '../../config';
import getUrlFiltered from '../../utils/helper_functions/getUrlFiltered';
import { setLoader } from '../loader/actions';

export function* fetchProductsSaga(action) {
  let response;
  yield put(setLoader('products', true));
  if (action.payload.filterName) {
    response = yield call(fetch, getUrlFiltered(PRODUCTS_URL,
      {
        [`${action.payload.filterName}`]: action.payload.filterValue,
      }));
  } else {
    response = yield call(fetch, getUrlFiltered(PRODUCTS_URL));
  }

  const data = yield response.json();
  yield put(setProductsList(data));
  yield put(setLoader('products', false));
}

export function* fetchSingleProductSaga(action) {
  yield put(setLoader('singleProduct', true));
  const response = yield call(fetch, getUrlFiltered(BASE_URL + action.payload.productId));
  const data = yield response.json();
  yield put(setViewedProduct(data));
  yield put(setLoader('singleProduct', false));
}

export function* deleteProductSaga(action) {
  yield put(setLoader('singleProduct', true));
  yield call(fetch, (BASE_URL + action.payload.productId), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/ld+json',
    },
  });

  yield put(fetchProductsData());
}

export function* watchFetchProductsSaga() {
  yield takeEvery(String(fetchProductsData), fetchProductsSaga);
}

export function* watchFetchSingleProductSaga() {
  yield takeEvery(String(fetchSingleProduct), fetchSingleProductSaga);
}

export function* watchDeleteProductSaga() {
  yield takeEvery(String(deleteProduct), deleteProductSaga);
}
